import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { selectRoles } from '@app/state/auth/auth.selectors';
import { Store } from '@ngrx/store';
import { AppState } from '@src/app/state';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Roles } from './Roles';

/**
 * Tira o parceiro da Dashboard: quem tem o papel PARTNER vai sempre para o Início do Comercial.
 *
 * O `/dashboard` redireciona para `dashboard-management`, então é ali que todo mundo cai ao
 * entrar, e é nessa rota que esta guarda fica. O Início (card 3517) mostra o resumo dos deals e
 * o que depende do parceiro.
 *
 * **Vale em toda navegação, não só na entrada** (pedido do Breno em 19/10/2026, card 3517: "remove
 * o Dashboard da visão dos parceiros"). Até ali a Dashboard era do parceiro por decisão do card
 * 2901 e a guarda só desviava vindo do `/login`; agora ela não existe para ele. O item saiu do
 * menu do parceiro, e qualquer link que ainda aponte para a Dashboard (logo, ícone de casa do
 * breadcrumb, URL salva) cai no Início em vez de abrir uma tela que não é dele.
 *
 * Devolve `UrlTree` em vez de navegar por efeito colateral: o roteador troca a navegação antes
 * de ativar a rota, então a Dashboard nem chega a montar.
 */
@Injectable({
  providedIn: 'root',
})
export class PartnerHomeGuard implements CanActivate {
  constructor(
    private store: Store<AppState>,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.store.select(selectRoles).pipe(
      take(1),
      map(roles =>
        roles?.includes(Roles.PARTNER)
          ? this.router.createUrlTree(['/dashboard/commercial/home'])
          : true
      )
    );
  }
}
